import React from "react";
import { Col, Container, Row } from "reactstrap";
import { TemplateimageData } from "../../Data/Demodata/Demo";
import { Link } from "react-router-dom";

const Demotemplate = () => {
  return (
    <section className='theme-bg pt-70 m-0 pb-0 grab'>
      <Container className='m-width'>
        <Row>
          <Col xl={5} md={6} className='offset-xl-1'>
            <div className='tamp-d-flex'>
              <div>
                <h2 className='tapl-title fadeInLeft-land-caption mb-5'>Stop thinking, Just grab it</h2>
                <Link to={'href'} className='btn btn-inverse'>
                  Download
                </Link>
              </div>
            </div>
          </Col>
          <Col xl={5} md={6} className='offset-xl-1'>
            <div className='home-right grab-img'>
              {TemplateimageData.map((image, index) => (
                <div className={image.className} key={index}>
                  <img src={image.src} alt={image.alt} className='img-fluid' />
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Demotemplate;
